module.exports = __webpack_public_path__ + "images/traffic_light.5c79dc961084d443067980221fe7edee.png";